import axios from 'axios';
const { REACT_APP_USER_DASHBOARD_FEAT } = process.env

export const getDashboardInstance = (baseURL: string ) => {
    const dashboardAxios = axios.create({
        baseURL: `https://${REACT_APP_USER_DASHBOARD_FEAT}.${baseURL}`,
        timeout: 10000, // 10 second timeout
    });
    return dashboardAxios
}